<ng-container *ngFor="let item of actionItems">
  <button
    mat-menu-item
    type="button"
    [attr.aria-label]="item.label"
    (click)="handleFullRecordAction(item.action)"
  >
    {{ item.label }}
  </button>
</ng-container>
